import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AdpApiService } from '../../../adp-api';

@Injectable({ providedIn: 'root' })
export class AdpAdminHttpClient {
  constructor(private httpApi: AdpApiService) {}

  public fetch(): Observable<Array<{}>> {
    return this.httpApi.get('workers').pipe(map(({ workers }: { workers: Array<[]> }) => workers));
  }
}
